/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const initialState = {
  data: [],
  isLoading: false,
  status: "INITIAL",
};

const EntitiesReducer = (state = initialState, action) => {
  if (action.type === "ENTITIES/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "ENTITIES/SUCCESS") {
    return {
      data: action.payload,
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === "ENTITIES/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};

const LeadershipsReducer = (state = initialState, action) => {
  if (action.type === "LEADERSHIPS/PENDING") {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === "LEADERSHIPS/SUCCESS") {
    return {
      data: action.payload,
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === "LEADERSHIPS/FAILED") {
    return {
      ...state,
      status: "FAILED",
      isLoading: false,
    };
  }
  return state;
};

export { EntitiesReducer, LeadershipsReducer };
